module.exports = __webpack_public_path__ + "media/images/version_merge/photostep_trash/like_this_cmnd_selfie-ca2d9bff3b66e82710fb1e6115c1d35b.jpg";